import { LoyaltySvgIcon, type LoyaltyIconProps } from './LoyaltySvgIcon';

export const WaterDropIcon = (props: LoyaltyIconProps): JSX.Element => (
    <LoyaltySvgIcon {...props}>
        <path d="M12 2.5c-4.2 5.05-6.5 8.63-6.5 11.5a6.5 6.5 0 0 0 13 0c0-2.87-2.3-6.45-6.5-11.5z" />
    </LoyaltySvgIcon>
);
